import React from 'react';
import { Route } from 'react-router-dom';
import RegisterVehicleIntro from 'modules/RegisterVehicle/IntroPage/IntroPage';
import RegisterVehicle from 'modules/RegisterVehicle/RegisterVehicle';
import Summary from 'modules/RegisterVehicle/Summary/Summary';
import { REGISTER_VEHICLE, REGISTER_VEHICLE_NEW, REGISTER_VEHICLE_SUMMARY } from './paths';
export default function RegisterVehicleRoutes() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: REGISTER_VEHICLE
  }, /*#__PURE__*/React.createElement(RegisterVehicleIntro, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: REGISTER_VEHICLE_NEW
  }, /*#__PURE__*/React.createElement(RegisterVehicle, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: REGISTER_VEHICLE_SUMMARY
  }, /*#__PURE__*/React.createElement(Summary, null)));
}